// store/modules/files/down.js
import FilesDownService from "@/services/filesDown.service";
import ToastService from "@/services/toast.service";

const delay = (ms) => {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
};

export const down = {
    namespaced: true,
    state: {
        downFailedArray: [],
    },
    getters: {
        downFailedArray(state) {
            return state.downFailedArray;
        },
        hasDownFailed(state) {
            return state.downFailedArray.length > 0;
        },
    },
    actions: {
        async fileDown({ state, rootState, dispatch }) {
            const files = JSON.parse(JSON.stringify(rootState.files.selectArray));
            if (!files || files.length === 0) {
                return;
            }

            for (let i = 0; i < files.length; i++) {
                const file = files[i];

                if (file.id === "false") {
                    continue;
                }

                try {
                    const response = await FilesDownService.fileDown(file);
                    if (!response || response.status !== 200) {
                        throw new Error("Download Error");
                    }
                } catch (error) {
                    console.log("fileDown error : ", error);
                    ToastService.error(`${file.name} Download Error`);

                    await dispatch("setDownFailedArray",
                        {
                            id: file.id,
                            name: file.name,
                        }
                    );
                }

                await delay(500);
            }

            if (state.downFailedArray.length > 0) {
                await dispatch("failedDownAgain");
            }
        },
        async failedDownAgain({ state, dispatch, }) {
            if (state.downFailedArray.length === 0) {
                return;
            }

            const files = JSON.parse(JSON.stringify(state.downFailedArray));
            for (let i = 0; i < files.length; i++) {
                const file = files[i];

                if (file.id === "false") {
                    continue;
                }

                await delay((i + 1) * 500);

                try {
                    const response = await FilesDownService.failedDown(file);
                    if (!response || response.status !== 200) {
                        throw new Error("Download Error");
                    }

                    ToastService.info(`${file.name} Download Start`);

                    await dispatch("removeDownFailedArray", file);
                } catch (error) {
                    console.log("failedDown error : ", error);
                    ToastService.error(`${file.name} Download Error`);
                }
            }
        },
        setDownFailedArray({ commit, }, file) {
            commit("addDownFailedArray", file);
        },
        removeDownFailedArray({ commit, }, file) {
            commit("removeDownFailedArray", file);
        },
        setCleanDownFailedArray({ commit, }) {
            commit("cleanDownFailedArray");
        },
    },
    mutations: {
        addDownFailedArray(state, file) {
            const exists = state.downFailedArray.some(
                    item =>
                        item.id === file.id &&
                        item.name === file.name
                );

            if (!exists) {
                state.downFailedArray.push({
                    id: file.id,
                    name: file.name,
                });
            }
        },
        removeDownFailedArray(state, file) {
            state.downFailedArray = state.downFailedArray.filter(
                    item =>
                        !(
                            item.id === file.id &&
                            item.name === file.name
                        )
                );
        },
        cleanDownFailedArray(state) {
            state.downFailedArray = [];
        },
    },
};